import { render, staticRenderFns } from "./RegionalStatisticsTab.vue?vue&type=template&id=a197554a&"
import script from "./RegionalStatisticsTab.vue?vue&type=script&lang=js&"
export * from "./RegionalStatisticsTab.vue?vue&type=script&lang=js&"
import style0 from "./RegionalStatisticsTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports